"use strict";const t=require("./index194.js"),r=require("./index42.js"),e=require("./index195.js");var i=t.toStringTagSupport,n=r.defineBuiltIn,o=e.objectToString;i||n(Object.prototype,"toString",o,{unsafe:!0});
